export default "__VITE_ASSET__Cc8EZiyF__"